import {Link} from 'react-router-dom'
import {ImagePicker} from '../../../../app/components/ImagePicker'
import {useAuth} from '../../../../app/modules/auth'
import {AvatarImage, getUserImageThumbnailUrl, getUserImageUrl} from '../../../../app/utils/img'
import {KTIcon} from '../../../helpers'
import {useState} from 'react'
import RoleEnum from '../../../../app/enums/RoleEnum'
import {logoutAuth} from '../../../../app/modules/auth/core/_requests'

function SidebarUserInfo() {
  const {currentUser, logout} = useAuth()
  const [showQr, setShowQr] = useState(false)
  const [showSurveyNotif, setShowSurveyNotif] = useState(false)
  const [logoutLoading, setLogoutLoading] = useState(false)
 

  const handleLogout = async () => {
    setLogoutLoading(true)
    var response = await logoutAuth()
    if (response.code === '0000') {
      logout()
    } else {
      setLogoutLoading(false)
    }
  }

  return (
    <div className='p-5'>
      <div className='card sidebar-userinfo__container'>
        <div className='sidebar-userinfo__container-top'>
          <div className='sidebar-userinfo__icon'>
            <span>
              <ImagePicker
                className='w-100'
                initialValue={`${getUserImageThumbnailUrl(currentUser?.id)}`}
                showEdit={false}
              />
            </span>
          </div>
          <div className='sidebar-userinfo__info animation'>
            <div className='sidebar-userinfo__role'>{currentUser?.name}</div>
          </div>
        </div>
        <div className='sidebar-userinfo__blockinfo'>
          {currentUser?.roleName === 'Student' && (
            <div className='mt-4'>
              <div className='sidebar-userinfo__major w-100 text-center'>
                {currentUser?.degreeName} - {currentUser?.majorName}
              </div>
            </div>
          )}
          {(currentUser?.roleName === 'Administrator' || currentUser?.roleName === 'Lecturer') && (
            <>
              <div className='sidebar-userinfo__major'>{currentUser?.roleName}</div>
            </>
          )}
        </div>
        <div className='sidebar-userinfo__action'>
          <div className='sidebar-userinfo__action-item'>
            <Link to={'/profile'}>
              <button
                type='button'
                className='btn btn-default btn-rounded btn-sm w-100 text-white'
                style={{backgroundColor: 'var(--dark-primary-color)'}}
              >
                <i className='fas fa-user-alt text-white'></i> Profile
              </button>
            </Link>
          </div>
        
          <div className='sidebar-userinfo__action-item'>
            <button
              onClick={handleLogout}
              disabled={logoutLoading}
              type='button'
              className='btn btn-default btn-rounded btn-sm w-100 text-white'
              style={{backgroundColor: 'var(--dark-primary-color)'}}
            >
              <i className='fas fa-sign-out-alt text-white'></i> Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SidebarUserInfo
